import {SvgIcon, SvgIconProps} from "@mui/material";
import React from "react";

const ShortStrangleSvg = (props: any) => (<svg width="34" height="34" viewBox="0 0 34 34" fill="none" xmlns="http://www.w3.org/2000/svg" >
        <path d="M1.02042 1V33" stroke="#88888866" strokeOpacity="0.4" strokeLinecap="round" strokeDasharray="5 5"/>
        <path d="M1 18.0225H33" stroke="#88888866" strokeOpacity="0.4" strokeLinecap="round" strokeDasharray="5 5"/>
        <path d="M1.78256 29.4941L4.87302 18.0225" stroke="#A40C0C" strokeWidth="2"/>
        <path d="M30.0181 29.4941L27.3243 18.0225" stroke="#A40C0C" strokeWidth="2"/>
        <path d="M4.87302 18.0225L7.3325 8.40106H25.2217L27.3243 18.0225" stroke="#089981" strokeWidth="2"/>
    </svg>
)
const ShortStrangle: React.FC<SvgIconProps> = React.memo((props) => (
    <SvgIcon {...props}>
        {ShortStrangleSvg(props)}
    </SvgIcon>
));
export default ShortStrangle